'use client';

import { Button, Group, Text, rem } from '@mantine/core';
import type { ContextModalProps } from '@mantine/modals';
import { useTranslations } from 'next-intl';

export type ConfirmModalProps = ContextModalProps<{
  content: string;
  actionLabel?: string;
}>;

export function ConfirmModal({
  context,
  id,
  innerProps: { content, actionLabel },
}: ConfirmModalProps) {
  const tActions = useTranslations('common.actions');
  const handleCloseModal = () => {
    context.closeModal(id);
  };

  return (
    <>
      <Text size="md" fw={500} c="neutral.6">
        {content}
      </Text>
      <Group justify="flex-end" mt="md" gap={8}>
        <Button onClick={handleCloseModal} size="sm" h={rem(40)}>
          {actionLabel ?? tActions('got_it')}
        </Button>
      </Group>
    </>
  );
}
